import { useEffect, useState } from "react"
import { Modal, ModalId, useUIState } from "../../../../../features/ui"
import { CreditPayment } from "../../../state/types"
import { UploadCreditReceiptForm } from "./uploadCreditReceiptForm"

type Props = {
    creditPayment?: CreditPayment
}

export const UploadCreditReceiptFormModal = (props: Props) => {
    const { creditPayment } = props
    
    const [key, setKey] = useState(0)
    const { openedModal } = useUIState()

    useEffect(() => setKey(key + 1), [openedModal])
    
    return (
        <Modal
            modalId={ModalId.UPLOAD_CREDIT_RECEIPT}
            title="Subir Comprobante de Pago"
            widthSize="m"
            actions={[]}
        >
            <UploadCreditReceiptForm
                key={key}
                creditPayment={creditPayment}
            />
        </Modal>
    )
}
